<template>
    <b-modal v-model="modalAberto" size="xl" @hidden="cancelar" button-size="md" hide-footer :title="prefix + title">

        <b-button id="localizar" class="ml-3 my-2" size="sm" style="height: 40px" pill variant="primary" @click="load">
            <div class="btn-size-alinhamento">
                <b-icon icon="arrow-clockwise" />
            </div>
            <b-tooltip target="localizar" title="Atualizar"></b-tooltip>
        </b-button>

        <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records" :fields="this.tableFields"
            :hover="true" show-empty>

            <template #empty>
                <p>Nenhum registro encontrado</p>
            </template>


            <template #table-busy>
                <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                </div>
            </template>

            <template #cell(antena)="data">
                {{ data.item.antena + (data.item.descricao ? (" - " + data.item.descricao) :
                    "") }}
            </template>

        </b-table>

        <b-row style="margin-top: 12px" v-if="records && records.length > 0">
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                    {{
                        totalPage }} -
                    {{ total }} registros</b-col>
                <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                    <b-form-select size="sm" v-model="perPage" @change="() => this.load()" :options="perPageOptions">
                    </b-form-select>
                </b-col>
            </b-col>
            <b-col cols="6">
                <div class="d-flex justify-content-end align-items-end">
                    <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                        :total-rows="total"></b-pagination>
                </div>
            </b-col>
        </b-row>

    </b-modal>
</template>

<script>
import moment from "moment";

import ConfirmMixin from "@/core/mixins/confirm"
import { ListResourceMixin } from "@/core/mixins/resource"
import ResourceService from "@/core/api/ResourceService";

export default {
    components: {

    },
    props: {
        leitor: Number,
        antena: {
            type: Number,
            default: null
        },

        prefix: {
            tipe: String,
            default: "",
        },
        title: {
            tipe: String,
            default: "Histórico Leitura Leitor",
        },


    },
    mixins: [ConfirmMixin, ListResourceMixin],
    data() {
        return {
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            page: 1,
            modalAberto: true,
        }
    },
    computed: {
        tableFields() {
            return [
                { key: "leitor", label: "Leitor" },
                { key: "antena", label: "Antena" },
                { key: "tag", label: "Etiqueta" },
                {
                    key: "dhCriacao", label: "Data Criação", formatter: (data) => moment(String(data)).format("DD/MM/YYYY"),
                },
                {
                    key: "dhLeitura", label: "Data Leitura", formatter: (data) => moment(String(data)).format("DD/MM/YYYY HH:mm:ss"),
                },

            ];
        },
    },
    beforeMount() {
        this.$service = new ResourceService(`/api/historico-leitura-leitor`);
        this.load();
    },
    watch: {
        page() {
            this.load();
        },
    },

    methods: {
        async load() {
            this.filtro = {};
            if (this.leitor != null)
                this.filtro.leitor = this.leitor;

            if (this.antena != null)
                this.filtro.antena = this.antena;

            this.busy = true;

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,

            });

        },

        cancelar() {
            this.$emit('fecharModal');
        },

    }
}

</script>